import { NgModule } from '@angular/core';
import { ConfigResource } from '@df/catalog/config/config.resource';
import { ICmsCoreAppSchemaService } from './app/icms-core-app-schema.service';
import { ICmsContentDraftService } from './content/draft/icms-content-draft.service';
import './content/page/default-page-type';
import { ICmsBlockResource } from './resource/block/icms-block.resource';
import { ICmsConfigResource } from './resource/config/icms-config.resource';
import { ICmsGroupResource } from './resource/group/icms-group.resource';
import { ICmsPageResource } from './resource/page/icms-page.resource';
import { ICmsUtilTemplateDirective } from './util/template/icms-util-template.directive';
import { ICmsUtilViewContainerDirective } from './util/view-container/icms-util-view-container.directive';
import { ICmsContentService } from './content/icms-content.service';
import { NICmsContentComponent } from './content';

ICmsContentService.registerComponentMetaPatch((meta: NICmsContentComponent.IMeta) => {
    // styles are only for non-block components
    if (meta.block) {
        meta.fields.push(...NICmsContentComponent.basicStyleFields);
    } else {
        meta.fields.push(...NICmsContentComponent.styleFields);
    }
});
@NgModule({
    declarations: [ICmsUtilViewContainerDirective, ICmsUtilTemplateDirective],
    exports: [ICmsUtilViewContainerDirective, ICmsUtilTemplateDirective],
    providers: [
        {
            provide: ConfigResource,
            useExisting: ICmsConfigResource
        },
        ICmsCoreAppSchemaService
    ]
})
export class ICmsCoreModule {
    /**
     * Make sure block resource is not dropped
     * @param iCmsBlockResource
     */
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    constructor(
        iCmsAppSchemaService: ICmsCoreAppSchemaService,
        iCmsBlockResource: ICmsBlockResource,
        iCmsPageResource: ICmsPageResource,
        iCmsContentDraftService: ICmsContentDraftService,
        iCmsGroupResource: ICmsGroupResource
    ) {}
}
